(function () {
  function h(tag, cls, text) { var n = document.createElement(tag); if (cls) n.className = cls; if (text != null) n.textContent = text; return n; }

  /* Prévient le header quand un produit est ajouté au panier (sans toucher au thème) */
  if (!window.__lhFetchWrapped && window.fetch) {
    window.__lhFetchWrapped = true;
    var nativeFetch = window.fetch;
    window.fetch = function () {
      var p = nativeFetch.apply(this, arguments);
      try {
        var a = arguments[0];
        var u = typeof a === 'string' ? a : (a && a.url) || '';
        if (/\/cart\/(add|change|update|clear)/.test(u)) {
          p.then(function () { document.dispatchEvent(new CustomEvent('lh:cart-changed')); }).catch(function () {});
        }
      } catch (e) {}
      return p;
    };
  }

  var ICON_MINUS = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><path d="M6 12h12"/></svg>';
  var ICON_PLUS = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><path d="M12 6v12M6 12h12"/></svg>';
  var ICON_TRASH = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M4 7h16M10 11v6M14 11v6M6 7l1 12a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2l1-12M9 7V4h6v3"/></svg>';

  function init(root) {
    if (root.getAttribute('data-ready')) return;
    root.setAttribute('data-ready', '1');

    var currency = root.getAttribute('data-currency') || 'EUR';
    var threshold = parseFloat(root.getAttribute('data-free-ship')) || 0;
    var browseUrl = root.getAttribute('data-browse-url') || '/collections/all';
    var cartUrl = root.getAttribute('data-cart-url') || '/cart';
    var upsellHandle = root.getAttribute('data-upsell') || 'de-10';
    var fmt;
    try { fmt = new Intl.NumberFormat('fr-FR', { style: 'currency', currency: currency }); }
    catch (e) { fmt = { format: function (n) { return n.toFixed(2) + ' €'; } }; }
    function money(cents) { return fmt.format(cents / 100); }

    var overlay = root.querySelector('[data-lh-overlay]');
    var panels = root.querySelectorAll('[data-panel]');
    var counts = root.querySelectorAll('[data-cart-count]');
    var cartBody = root.querySelector('[data-cart-body]');
    var cartFoot = root.querySelector('[data-cart-foot]');
    var wishBody = root.querySelector('[data-wish-body]');
    var busy = false;
    var renderSeq = 0;

    /* ----- Barre qui se réduit au défilement ----- */
    var ticking = false;
    function onScroll() { ticking = false; root.classList.toggle('is-scrolled', window.scrollY > 24); }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(onScroll); } }, { passive: true });
    onScroll();

    /* ----- Panneaux ----- */
    function openPanel(name) {
      Array.prototype.forEach.call(panels, function (p) { p.classList.toggle('is-open', p.getAttribute('data-panel') === name); });
      overlay.classList.add('is-open');
      document.documentElement.classList.add('lh-lock');
      if (name === 'cart') loadCart();
      if (name === 'wishlist') loadWishlist();
      if (name === 'search') {
        setTimeout(function () { var i = root.querySelector('[data-search-input]'); if (i) i.focus(); }, 350);
      }
    }
    function closeAll() {
      Array.prototype.forEach.call(panels, function (p) { p.classList.remove('is-open'); });
      overlay.classList.remove('is-open');
      document.documentElement.classList.remove('lh-lock');
    }
    Array.prototype.forEach.call(root.querySelectorAll('[data-open]'), function (btn) {
      btn.addEventListener('click', function () { openPanel(btn.getAttribute('data-open')); });
    });
    Array.prototype.forEach.call(root.querySelectorAll('[data-close]'), function (btn) { btn.addEventListener('click', closeAll); });
    overlay.addEventListener('click', closeAll);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });

    /* ----- Compteur du panier ----- */
    function setCount(n) {
      Array.prototype.forEach.call(counts, function (c) {
        var changed = c.getAttribute('data-count') !== String(n);
        c.textContent = n;
        c.setAttribute('data-count', n);
        if (changed) { c.classList.remove('is-bump'); void c.offsetWidth; c.classList.add('is-bump'); }
      });
    }
    function refreshCount() {
      fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) { setCount(c.item_count); }).catch(function () {});
    }
    document.addEventListener('lh:cart-changed', function () {
      if (busy) return;
      refreshCount();
      var panel = root.querySelector('[data-panel="cart"]');
      if (panel && panel.classList.contains('is-open')) loadCart();
    });
    window.addEventListener('pageshow', refreshCount);

    /* ----- Panier ----- */
    function emptyState(text, label, url) {
      var e = h('div', 'lh-empty');
      e.appendChild(h('p', null, text));
      var a = h('a', 'lh-btn lh-btn--primary', label);
      a.href = url;
      e.appendChild(a);
      return e;
    }
    function lineEl(imgSrc, title, url, meta, price) {
      var line = h('div', 'lh-line');
      var imgLink = h('a');
      imgLink.href = url;
      if (imgSrc) {
        var img = document.createElement('img');
        img.className = 'lh-line__img';
        img.src = imgSrc;
        img.alt = title;
        img.width = 74;
        img.height = 74;
        img.loading = 'lazy';
        imgLink.appendChild(img);
      } else {
        imgLink.appendChild(h('div', 'lh-line__img'));
      }
      var info = h('div');
      var name = h('a', 'lh-line__name', title);
      name.href = url;
      info.appendChild(name);
      if (meta) info.appendChild(h('div', 'lh-line__meta', meta));
      line.appendChild(imgLink);
      line.appendChild(info);
      line.appendChild(h('div', 'lh-line__price', price));
      return line;
    }

    /* Ligne du panier avec quantité modifiable et bouton retirer */
    function cartLineEl(item, index) {
      var variant = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
      var line = lineEl(item.image ? item.image + (item.image.indexOf('?') > -1 ? '&' : '?') + 'width=200' : '', item.product_title, item.url, variant, money(item.final_line_price));
      line.classList.add('lh-line--cart');
      line.setAttribute('data-line', index + 1);
      var ctrl = h('div', 'lh-qtyrow');
      var qty = h('div', 'lh-qty');
      var minus = h('button', 'lh-qty__btn'); minus.type = 'button'; minus.innerHTML = ICON_MINUS; minus.setAttribute('aria-label', 'Retirer un exemplaire');
      var val = h('span', 'lh-qty__val', String(item.quantity));
      var plus = h('button', 'lh-qty__btn'); plus.type = 'button'; plus.innerHTML = ICON_PLUS; plus.setAttribute('aria-label', 'Ajouter un exemplaire');
      qty.appendChild(minus); qty.appendChild(val); qty.appendChild(plus);
      var rm = h('button', 'lh-rm'); rm.type = 'button'; rm.innerHTML = ICON_TRASH + '<span>Retirer</span>'; rm.setAttribute('aria-label', 'Retirer ' + item.product_title);
      ctrl.appendChild(qty); ctrl.appendChild(rm);
      line.children[1].appendChild(ctrl);
      minus.addEventListener('click', function () { changeLine(line, index + 1, item.quantity - 1); });
      plus.addEventListener('click', function () { changeLine(line, index + 1, item.quantity + 1); });
      rm.addEventListener('click', function () { changeLine(line, index + 1, 0); });
      return line;
    }
    function changeLine(line, lineNo, q) {
      if (busy) return;
      busy = true;
      line.classList.add(q === 0 ? 'is-leaving' : 'is-busy');
      fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ line: lineNo, quantity: Math.max(0, q) }) })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          busy = false;
          if (cart && cart.items) { setCount(cart.item_count); renderCart(cart); } else { loadCart(); }
          if (cart && cart.status && cart.description) showLineError(cart.description);
        })
        .catch(function () { busy = false; loadCart(); });
    }
    function showLineError(msg) {
      var e = h('div', 'lh-alert', msg);
      cartBody.insertBefore(e, cartBody.firstChild);
      setTimeout(function () { e.remove(); }, 4000);
    }

    /* Suggestions "Complète ton look" */
    var upsellCache = null;
    function getUpsell() {
      if (upsellCache) return Promise.resolve(upsellCache);
      return fetch('/collections/' + upsellHandle + '/products.json?limit=24').then(function (r) { return r.json(); })
        .then(function (d) { upsellCache = (d && d.products) || []; return upsellCache; })
        .catch(function () { return []; });
    }
    function renderUpsell(cart, host) {
      var my = ++renderSeq;
      getUpsell().then(function (products) {
        if (my !== renderSeq) return;
        var inCart = {};
        cart.items.forEach(function (i) { inCart[i.product_id] = true; });
        var list = products.filter(function (p) {
          if (inCart[p.id]) return false;
          return p.variants && p.variants.some(function (v) { return v.available; });
        }).slice(0, 8);
        if (!list.length) return;
        var wrap = h('div', 'lh-up');
        var head = h('div', 'lh-up__head');
        head.appendChild(h('p', 'lh-up__title', cart.items.length ? 'Complète ton look ✨' : 'Nos petits coups de cœur'));
        head.appendChild(h('span', 'lh-up__hint', 'glisse →'));
        wrap.appendChild(head);
        var track = h('div', 'lh-up__track');
        list.forEach(function (p) {
          var v = p.variants.filter(function (x) { return x.available; })[0];
          var card = h('div', 'lh-up__card');
          var a = h('a', 'lh-up__img'); a.href = '/products/' + p.handle;
          if (p.images && p.images[0]) {
            var img = document.createElement('img');
            img.src = p.images[0].src + (p.images[0].src.indexOf('?') > -1 ? '&' : '?') + 'width=300';
            img.alt = p.title; img.loading = 'lazy'; img.width = 150; img.height = 150;
            a.appendChild(img);
          }
          card.appendChild(a);
          var name = h('a', 'lh-up__name', p.title); name.href = '/products/' + p.handle;
          card.appendChild(name);
          card.appendChild(h('span', 'lh-up__price', fmt.format(parseFloat(v.price))));
          var multi = p.variants.length > 1;
          var btn = h(multi ? 'a' : 'button', 'lh-up__btn', multi ? 'Choisir' : '+ Ajouter');
          if (multi) { btn.href = '/products/' + p.handle; }
          else {
            btn.type = 'button';
            btn.addEventListener('click', function () {
              if (busy) return;
              busy = true; btn.disabled = true; btn.textContent = '…';
              fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: v.id, quantity: 1 }) })
                .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
                .then(function () { btn.textContent = 'Ajouté ✓'; btn.classList.add('is-added'); busy = false; setTimeout(loadCart, 500); })
                .catch(function () { busy = false; btn.disabled = false; btn.textContent = 'Indisponible'; });
            });
          }
          card.appendChild(btn);
          track.appendChild(card);
        });
        wrap.appendChild(track);
        host.appendChild(wrap);
      });
    }

    function renderCart(cart) {
      cartBody.innerHTML = '';
      cartFoot.innerHTML = '';
      if (!cart.items.length) {
        cartFoot.hidden = true;
        cartBody.appendChild(emptyState('Ton panier est vide pour le moment.', 'Découvrir nos bijoux', browseUrl));
        renderUpsell(cart, cartBody);
        return;
      }
      cartFoot.hidden = false;
      if (threshold > 0) {
        var total = cart.total_price / 100;
        var left = threshold - total;
        var pct = Math.max(0, Math.min(100, (total / threshold) * 100));
        var ship = h('div', 'lh-ship');
        var txt = h('div');
        if (left > 0) txt.innerHTML = '🚚 Plus que <strong>' + fmt.format(left) + '</strong> pour la livraison offerte';
        else txt.textContent = 'Bravo, la livraison est offerte 🎉';
        ship.appendChild(txt);
        var track = h('div', 'lh-ship__track');
        var fill = h('span', 'lh-ship__fill');
        track.appendChild(fill);
        ship.appendChild(track);
        cartBody.appendChild(ship);
        requestAnimationFrame(function () { requestAnimationFrame(function () { fill.style.width = pct + '%'; }); });
      }
      cart.items.forEach(function (item, i) { cartBody.appendChild(cartLineEl(item, i)); });
      renderUpsell(cart, cartBody);

      var sub = h('div', 'lh-sub');
      sub.appendChild(h('span', null, 'Sous-total'));
      sub.appendChild(h('strong', null, money(cart.total_price)));
      cartFoot.appendChild(sub);
      var btns = h('div', 'lh-btns');
      var buy = h('a', 'lh-btn lh-btn--primary lh-btn--shine', 'Commander');
      buy.href = '/checkout';
      var view = h('a', 'lh-btn lh-btn--ghost', 'Voir le panier');
      view.href = cartUrl;
      btns.appendChild(buy);
      btns.appendChild(view);
      cartFoot.appendChild(btns);
      cartFoot.appendChild(h('p', 'lh-secure', '🔒 Paiement sécurisé · Retours sous 14 jours'));
    }
    function loadCart() {
      fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) { setCount(cart.item_count); renderCart(cart); })
        .catch(function () { cartBody.innerHTML = ''; cartBody.appendChild(h('div', 'lh-empty', 'Impossible de charger le panier.')); });
    }

    /* ----- Favoris ----- */
    function loadWishlist() {
      var ids = [];
      try { ids = JSON.parse(localStorage.getItem('lilova_wishlist') || '[]'); } catch (e) {}
      wishBody.innerHTML = '';
      if (!ids.length) {
        wishBody.appendChild(emptyState('Aucun favori pour le moment. Clique sur le cœur d’un bijou pour le retrouver ici.', 'Découvrir nos bijoux', browseUrl));
        return;
      }
      wishBody.appendChild(h('div', 'lh-empty', 'Chargement...'));
      fetch('/products.json?limit=250').then(function (r) { return r.json(); }).then(function (data) {
        var matched = data.products.filter(function (p) { return ids.indexOf(String(p.id)) !== -1; });
        wishBody.innerHTML = '';
        if (!matched.length) { wishBody.appendChild(h('div', 'lh-empty', 'Favoris introuvables.')); return; }
        matched.forEach(function (p) {
          var price = p.variants && p.variants[0] ? fmt.format(parseFloat(p.variants[0].price)) : '';
          wishBody.appendChild(lineEl(p.images[0] ? p.images[0].src : '', p.title, '/products/' + p.handle, '', price));
        });
      }).catch(function () { wishBody.innerHTML = ''; wishBody.appendChild(h('div', 'lh-empty', 'Impossible de charger les favoris.')); });
    }
  }

  function initAll() {
    var list = document.querySelectorAll('.lh[data-lilova-header]');
    for (var i = 0; i < list.length; i++) init(list[i]);
  }
  initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
